import { DOCUMENT } from '@angular/common';
import {Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class CustomCookieService extends CookieService {
    allowedPostData = [
        'clientId',
        'courseId',
        'GreenId',
        'selectedFormatDate'
    ]
    
    constructor(
        @Inject(DOCUMENT) document: any,
        @Inject(PLATFORM_ID) platformId: Object
    ) {
        super(document, platformId);
    }
  
    override get(name: string): string {
        let originalValue: string | null = super.get(name);
        if(originalValue) {
            return originalValue;
        }

        if(!originalValue) {
            originalValue = localStorage.getItem(name) ?? ''
        }

        return originalValue
    }

    // CookieService.set has multiple overloads
    // 1. Declare the first overload (Positional Arguments)
    override set(name: string, value: string, expires?: number | Date, path?: string, domain?: string, secure?: boolean, sameSite?: 'Lax' | 'None' | 'Strict'): void;
    // 2. Declare the second overload (Options Object)
    override set(name: string, value: string, options?: { expires?: number | Date; path?: string; domain?: string; secure?: boolean; sameSite?: 'Lax' | 'None' | 'Strict' }): void;
    // 3. The actual implementation that handles both
    override set(name: string, value: string, expiresOrOptions?: any, path?: string, domain?: string, secure?: boolean, sameSite?: 'Lax' | 'None' | 'Strict'): void {

        // Call super based on which overload was used
        if (typeof expiresOrOptions === 'object' && !(expiresOrOptions instanceof Date)) {
            super.set(name, value, expiresOrOptions);
        } else {
            super.set(name, value, expiresOrOptions, path, domain, secure, sameSite);
        }
        
        if(this.allowedPostData.includes(name)) {
            // Send the value out of the iframe
            if (window.parent && window !== window.parent) {
                localStorage.setItem(name, value)
                window.parent.postMessage(
                    {
                        type: 'metaDataValue',
                        key: name,
                        value: value
                    },
                    '*' // or replace '*' with specific origin for security
                );
            }
        }
    }
}
